module.exports = __webpack_public_path__ + "img/2018-mlsexpansion.b95fc38b.jpg";